module.exports = __webpack_public_path__ + "static/media/sprts.3c053bd6.jpg";